export const USER_ROLES = [
    {label: 'Owner', value: 'owner'},
    {label: 'Operator', value: 'operator'},
    {label: 'Accountant', value: 'accountant'},
    {label: 'Other', value: 'other'}
];